module.exports = __webpack_public_path__ + "img/close-outline.3a7bd271.svg";